import { Locale } from '../types';

export const translations = {
  // Header
  appTitle: {
    [Locale.en]: 'Commercial Request',
    [Locale.ru]: 'Коммерческое Предложение',
    [Locale.kz]: 'Коммерциялық Ұсыныс'
  },
  toMainWebsite: {
    [Locale.en]: 'To the main website',
    [Locale.ru]: 'На главный сайт',
    [Locale.kz]: 'Негізгі сайтқа'
  },
  logout: {
    [Locale.en]: 'Logout',
    [Locale.ru]: 'Выйти',
    [Locale.kz]: 'Шығу'
  },

  // Agreement
  viewAgreement: {
    [Locale.en]: 'View Agreement',
    [Locale.ru]: 'Просмотреть Соглашение',
    [Locale.kz]: 'Келісімді Қарау'
  },
  closeAgreement: {
    [Locale.en]: 'Close',
    [Locale.ru]: 'Закрыть',
    [Locale.kz]: 'Жабу'
  },
  agreementLoading: {
    [Locale.en]: 'Loading agreement...',
    [Locale.ru]: 'Загрузка соглашения...',
    [Locale.kz]: 'Келісімді жүктеу...'
  },
  agreementError: {
    [Locale.en]: 'Failed to load agreement',
    [Locale.ru]: 'Не удалось загрузить соглашение',
    [Locale.kz]: 'Келісімді жүктеу мүмкін болмады'
  },
  retry: {
    [Locale.en]: 'Retry',
    [Locale.ru]: 'Повторить',
    [Locale.kz]: 'Қайталау'
  },

  // Main sections
  technologyStack: {
    [Locale.en]: 'Technology Stack',
    [Locale.ru]: 'Технологический Стек',
    [Locale.kz]: 'Технологиялық Стек'
  },

  // Calculator
  costCalculator: {
    [Locale.en]: 'Cost Calculator',
    [Locale.ru]: 'Калькулятор Стоимости',
    [Locale.kz]: 'Құн Калькуляторы'
  },
  selectedOptions: {
    [Locale.en]: 'Selected Options',
    [Locale.ru]: 'Выбранные Опции',
    [Locale.kz]: 'Таңдалған Опциялар'
  },
  totalPrice: {
    [Locale.en]: 'Total Price',
    [Locale.ru]: 'Общая Стоимость',
    [Locale.kz]: 'Жалпы Құны'
  },
  projectTimeline: {
    [Locale.en]: 'Project Timeline',
    [Locale.ru]: 'Сроки Проекта',
    [Locale.kz]: 'Жоба Мерзімі'
  },
  hourlyCosts: {
    [Locale.en]: 'Ongoing Hourly Costs',
    [Locale.ru]: 'Текущие Почасовые Расходы',
    [Locale.kz]: 'Ағымдағы Сағаттық Шығындар'
  },
  clearAllSelections: {
    [Locale.en]: 'Clear All Selections',
    [Locale.ru]: 'Очистить Все Выборы',
    [Locale.kz]: 'Барлық Таңдауларды Тазалау'
  },
  clearAll: {
    [Locale.en]: 'Clear All',
    [Locale.ru]: 'Очистить Все',
    [Locale.kz]: 'Барлығын Тазалау'
  },
  selectedItems: {
    [Locale.en]: 'Selected Items',
    [Locale.ru]: 'Выбранные Товары',
    [Locale.kz]: 'Таңдалған Тауарлар'
  },

  // Currency & Language
  currency: {
    [Locale.en]: 'Currency',
    [Locale.ru]: 'Валюта',
    [Locale.kz]: 'Валюта'
  },
  language: {
    [Locale.en]: 'Language',
    [Locale.ru]: 'Язык',
    [Locale.kz]: 'Тіл'
  },

  // Section badges
  required: {
    [Locale.en]: 'Required',
    [Locale.ru]: 'Обязательно',
    [Locale.kz]: 'Міндетті'
  },
  optional: {
    [Locale.en]: 'Optional',
    [Locale.ru]: 'Опционально',
    [Locale.kz]: 'Қосымша'
  },
  selected: {
    [Locale.en]: 'selected',
    [Locale.ru]: 'выбрано',
    [Locale.kz]: 'таңдалды'
  },

  // Option details
  pros: {
    [Locale.en]: 'Pros',
    [Locale.ru]: 'Преимущества',
    [Locale.kz]: 'Артықшылықтар'
  },
  cons: {
    [Locale.en]: 'Cons',
    [Locale.ru]: 'Недостатки',
    [Locale.kz]: 'Кемшіліктер'
  },
  price: {
    [Locale.en]: 'Price',
    [Locale.ru]: 'Цена',
    [Locale.kz]: 'Баға'
  },
  timeline: {
    [Locale.en]: 'Timeline',
    [Locale.ru]: 'Сроки',
    [Locale.kz]: 'Мерзім'
  },
  hourly_rate: {
    [Locale.en]: 'Hourly Rate',
    [Locale.ru]: 'Почасовая Ставка',
    [Locale.kz]: 'Сағаттық Ставка'
  },
  hour: {
    [Locale.en]: 'hour',
    [Locale.ru]: 'час',
    [Locale.kz]: 'сағат'
  },
  days: {
    [Locale.en]: 'days',
    [Locale.ru]: 'дней',
    [Locale.kz]: 'күн'
  },
  day: {
    [Locale.en]: 'day',
    [Locale.ru]: 'день',
    [Locale.kz]: 'күн'
  },
  weeks: {
    [Locale.en]: 'weeks',
    [Locale.ru]: 'недель',
    [Locale.kz]: 'апта'
  },
  week: {
    [Locale.en]: 'week',
    [Locale.ru]: 'неделя',
    [Locale.kz]: 'апта'
  },
  months: {
    [Locale.en]: 'months',
    [Locale.ru]: 'месяцев',
    [Locale.kz]: 'ай'
  },
  month: {
    [Locale.en]: 'month',
    [Locale.ru]: 'месяц',
    [Locale.kz]: 'ай'
  },

  // Summary
  projectSummary: {
    [Locale.en]: 'Project Summary',
    [Locale.ru]: 'Сводка Проекта',
    [Locale.kz]: 'Жоба Жиынтығы'
  },
  includedServices: {
    [Locale.en]: 'Included Services',
    [Locale.ru]: 'Включенные Услуги',
    [Locale.kz]: 'Қосылған Қызметтер'
  },
  requiredServices: {
    [Locale.en]: 'Required Services',
    [Locale.ru]: 'Обязательные Услуги',
    [Locale.kz]: 'Міндетті Қызметтер'
  },
  alwaysIncluded: {
    [Locale.en]: 'Always Included',
    [Locale.ru]: 'Всегда Включено',
    [Locale.kz]: 'Әрқашан Қосылған'
  },
  ongoingCosts: {
    [Locale.en]: 'Ongoing Costs',
    [Locale.ru]: 'Текущие Расходы',
    [Locale.kz]: 'Ағымдағы Шығындар'
  },
  noOptionsSelected: {
    [Locale.en]: 'No options selected yet',
    [Locale.ru]: 'Опции еще не выбраны',
    [Locale.kz]: 'Опциялар әлі таңдалмаған'
  },
  startSelecting: {
    [Locale.en]: 'Start by selecting technologies from the sections',
    [Locale.ru]: 'Начните с выбора технологий из секций',
    [Locale.kz]: 'Бөлімдерден технологияларды таңдаудан бастаңыз'
  },
  sendSummary: {
    [Locale.en]: 'Complete',
    [Locale.ru]: 'Готово',
    [Locale.kz]: 'Аяқтау'
  },
  generatingDocument: {
    [Locale.en]: 'Generating document...',
    [Locale.ru]: 'Создание документа...',
    [Locale.kz]: 'Құжатты жасау...'
  },
  shareConfiguration: {
    [Locale.en]: 'Share Configuration',
    [Locale.ru]: 'Поделиться Конфигурацией',
    [Locale.kz]: 'Конфигурацияны Бөлісу'
  },

  // Validation
  requiredSections: {
    [Locale.en]: 'Required Sections',
    [Locale.ru]: 'Обязательные Секции',
    [Locale.kz]: 'Міндетті Бөлімдер'
  },
  isRequired: {
    [Locale.en]: 'is required',
    [Locale.ru]: 'обязательно',
    [Locale.kz]: 'міндетті'
  },
  shouldBeChosen: {
    [Locale.en]: 'should be chosen',
    [Locale.ru]: 'должны быть выбраны',
    [Locale.kz]: 'таңдалуы керек'
  },

  // Loading & Error
  loading: {
    [Locale.en]: 'Loading project configuration...',
    [Locale.ru]: 'Загрузка конфигурации проекта...',
    [Locale.kz]: 'Жоба конфигурациясын жүктеу...'
  },
  error: {
    [Locale.en]: 'Error',
    [Locale.ru]: 'Ошибка',
    [Locale.kz]: 'Қате'
  },
  failedToLoad: {
    [Locale.en]: 'Failed to load project data',
    [Locale.ru]: 'Не удалось загрузить данные проекта',
    [Locale.kz]: 'Жоба деректерін жүктеу мүмкін болмады'
  },

  // Footer
  footer: {
    [Locale.en]: '© 2025 Irlen. All rights reserved.',
    [Locale.ru]: '© 2025 Irlen. Все права защищены.',
    [Locale.kz]: '© 2025 Irlen. Барлық құқықтар қорғалған.'
  },

  // Time formatting
  noSelection: {
    [Locale.en]: 'No selection',
    [Locale.ru]: 'Нет выбора',
    [Locale.kz]: 'Таңдау жоқ'
  }
};

// Helper function to get translated text
export const t = (key: keyof typeof translations, locale: Locale): string => {
  return translations[key][locale] || translations[key][Locale.en];
};
